import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPaste,
  faCompassDrafting,
  faClone,
  faThumbsUp,
} from "@fortawesome/free-solid-svg-icons";
import "./KipCards.css";
import { Link } from "react-router-dom";

const cards = [
  {
    icon: faPaste,
    title: "CONFERENCE PROGRAM",
    description: "KIPPRA Annual Regional Conference program..",
    background: "#f2f2f2",
    link: "/program",
  },
  {
    icon: faCompassDrafting,
    title: "CONFERENCE VENUE",
    description: "Click to see the venue for the program...",
    background: "#d9d9d9",
    link: "/venue",
  },
  {
    icon: faClone,
    title: "DEMOGRAPHICS",
    description: "See more on Demographics >>>",
    background: "#c6c6c6",
    link: "/demographics",
  },
  {
    icon: faThumbsUp,
    title: "YOUTH EVENT",
    description: "Click to see more...",
    background: "#b3b3b3",
    link: "/youth_event",
  },
];

const Card = ({ icon, title, description, link }) => {
  return (
    <div className="card">
      <Link to={link} className="card-link">
        <div className="card-icon">
          <FontAwesomeIcon icon={icon} />
        </div>
        <div className="card-content">
          <h2 className="card-title">{title}</h2>
          <p className="card-description">{description}</p>
        </div>
      </Link>
    </div>
  );
};

const KipCards = () => {
  return (
    <div className="App">
      <div className="cards">
        {cards.map((card, index) => (
          <Card key={index} {...card} />
        ))}
      </div>
    </div>
  );
};

export default KipCards;
